export default __webpack_public_path__ + "static/media/document.0a55d460.svg";